var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeDarkMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 19.999,
    viewBox: "0 0 16 19.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_23463",
    "data-name": "Path 23463",
    d: "M-7693-2381a1,1,0,0,1-1-1,8.009,8.009,0,0,1,8-8,8.007,8.007,0,0,1,8,8,1,1,0,0,1-1,1Zm1.083-2h11.833a6.009,6.009,0,0,0-5.916-5A6.009,6.009,0,0,0-7691.917-2383Zm.917-13a5,5,0,0,1,5-5,5.005,5.005,0,0,1,5,5,5.007,5.007,0,0,1-5,5A5.006,5.006,0,0,1-7691-2396Zm2,0a3,3,0,0,0,3,3,3,3,0,0,0,3-3,3,3,0,0,0-3-3A3,3,0,0,0-7689-2396Z",
    transform: "translate(7694 2401)",
    fill: "#fff",
    opacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDarkMode);
export default __webpack_public_path__ + "static/media/HomeDarkMode.383bb1576c278f96df6d7a1b4a98e08e.svg";
export { ForwardRef as ReactComponent };